import { callApi } from "./api";
import * as transforms from "./transforms";

function transformProductOptionsResponse(response) {
  return response.map((option) => transforms.transformProductOption(option));
}

export const fetchProductOptionsForProductType = (productTypeId) => {
  return callApi("options-by-type/" + productTypeId + "?_format=json").then(
    (response) => {
      if (response.response && response.response.length) {
        return { response: transformProductOptionsResponse(response.response) };
      } else {
        return { response: {} };
      }
    },
  );
};

export const fetchLayerColors = (layer_id, productOptionId) => {
  return callApi(
    "productoption/" + productOptionId + "/colors/layer?_format=json",
  ).then((response) => {
    if (response.response) {
      return {
        response: {
          colors: transforms.transformColorsResponse(response.response),
          type: "Layer",
          layer_id,
          product_option_id: productOptionId,
        },
      };
    } else {
      return { response: {} };
    }
  });
};

export const fetchSupportingColors = (layer_id, productOptionId) => {
  return callApi(
    "productoption/" + productOptionId + "/colors/supporting?_format=json",
  ).then((response) => {
    if (response.response) {
      return {
        response: {
          colors: transforms.transformColorsResponse(response.response),
          type: "Supporting",
          layer_id,
          product_option_id: productOptionId,
        },
      };
    } else {
      return { response: {} };
    }
  });
};
